import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { HomeService } from './home.service';
import { CommonUtilitiesService } from '../common-utilities.service';
import { constants } from '../constants';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  users: Object;
  itemsdata :any = [];
  listItemsImg :any = [];

  constructor(public LANG:CommonUtilitiesService, private homeService: HomeService, private _sanitizer: DomSanitizer) { }
  /**
   * Description: Método que al cargar la página genera los items del carousel dinámicamente
   * Autor: Steven Sterling
   * @param N/A
   * @return N/A
   */
  ngOnInit() {
      this.homeService.getCarouselList({"category":constants.CATEGORY_HOME}).subscribe((dataInfo => {
        
      if(dataInfo['responseCode'] ==  constants.SUCCESS_WS_RESPONSE_CODE){
        this.listItemsImg = dataInfo['obj'];
      }

      }),
      (err) => {
        this.listItemsImg = [];
      });
  }

  /**
   * Description: Método que carga los items del caroules
   * Autor: Steven Sterling
   * @param array :lista de items 
   * @param size: cantidad de items por mostrar 
   * @return results : items generados dinamicamente
   */
  loadItemsCarousel(array, size) {
    let results = [];
    results = [];
    while (array.length) {
      results.push(array.splice(0, size));
    }
    return results;
  }

  formatImgBg(base64Img){
    return this._sanitizer.bypassSecurityTrustStyle(`url(${constants.BASE64_INIT}${base64Img})`);
  }

  formatImg(base64Img){
    return this._sanitizer.bypassSecurityTrustResourceUrl(`data:image/svg;charset=utf-8;base64,${base64Img}`);
  }

}
